import { IDamagedPartModal } from '@/common/components/adjusterReport/damagedPoints/DamagedPartModal.type';
import Button from '@/common/components/base/button/Button';
import CheckBox from '@/common/components/base/checkBox/CheckBox';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import getVehicleTypeQueryOption from '@/common/queries/getVehicleType/getVehicleTypeQueryOPtion';
import { GetVehiclePartQueryResponseType } from '@/common/queries/selections/getVehiclePart/getVehiclePartQuery.type';
import { getVehiclePartQueryOptions } from '@/common/queries/selections/getVehiclePart/getVehiclePartQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

type DamagePointsMap = {
  [key: number]: boolean | undefined;
};

export default (props: IDamagedPartModal) => (
  <MainModal closeModal={props.closeModal} open={props.open}>
    <DamagedPartModal {...props} />
  </MainModal>
);

const DamagedPartModal: React.FC<IDamagedPartModal> = ({
  closeModal,
  selectedPart,
}) => {
  const { damagedId, id } = useParams();
  const methods = useForm<GetVehiclePartQueryResponseType>();
  const { selectedSideName, damagedPoints, updateDamagedPoints } =
    useDamagedPoints();
  const [disabled, setDisable] = useState<number[]>([]);

  const { data: fileVehicleType, isSuccess } = useQuery(
    getVehicleTypeQueryOption({ damaged_pk: damagedId, file_pk: id! }),
  );
  const { data: vehiclePartData, isPending } = useQuery(
    getVehiclePartQueryOptions({
      side: selectedPart,
      enabled: isSuccess,
      vehicleType: fileVehicleType?.id!,
    }),
  );

  const onSubmit = (data: DamagePointsMap) => {
    const selectedData = Object.entries(data).flatMap(([id, value]) => {
      const existItem = damagedPoints?.find((item) => +item.id === +id);

      return value
        ? (existItem ?? {
            id,
            name:
              vehiclePartData?.find((item) => item?.id?.toString() === id)
                ?.name ?? '',
            side: selectedSideName ?? '',
          })
        : [];
    });

    const prevItems = damagedPoints.filter(
      (item) => item.side !== selectedSideName,
    );

    updateDamagedPoints([...prevItems, ...selectedData]);

    closeModal();
  };

  useEffect(() => {
    if (damagedPoints) {
      vehiclePartData?.forEach((item) => {
        const damaged = damagedPoints?.find(
          (damagedItem) => damagedItem?.id === item?.id?.toString(),
        );
        if (damaged) {
          damaged.disabled && setDisable((prev) => [...prev, item.id]);
          methods.setValue(
            item?.id?.toString() as keyof GetVehiclePartQueryResponseType,
            'true',
          );
        }
      });
    }
  }, [damagedPoints, vehiclePartData]);

  if (isPending) {
    return (
      <Box display={'flex'} justifyContent={'center'}>
        <CircularLoading color="colors.purple-primary" />
      </Box>
    );
  }
  return (
    <>
      <TitleDescription>{`${selectedPart?.name?.fa_const} وسیله‌نقلیه`}</TitleDescription>
      <FormProvider {...methods}>
        <Box h={300} overflowY="auto" mt={24}>
          {vehiclePartData?.map((item) => {
            return (
              <label key={item?.id} htmlFor={item.id.toString()}>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={8}
                  pb={16}
                  pt={16}
                  px={10}
                  borderBottom={'1px solid #F0F0F0'}
                >
                  <CheckBox
                    id={item.id.toString()}
                    disabled={disabled.includes(+item.id)}
                    name={item?.id?.toString()}
                  />
                  <Typography textStyle="b2">{` ${item?.side?.fa_const} - `}</Typography>
                  <Typography mr={2} textStyle="b2">
                    {` ${item?.name} `}
                  </Typography>
                </Box>
              </label>
            );
          })}
        </Box>
        <Flex gap={8}>
          <Button
            w="50%"
            mt={40}
            color="common"
            variant="outlined"
            onClick={closeModal}
          >
            بازگشت
          </Button>
          <Button
            disabled={!methods.formState.isValid}
            w="50%"
            type="submit"
            onClick={methods.handleSubmit(onSubmit)}
            mt={40}
          >
            تایید
          </Button>
        </Flex>
      </FormProvider>
    </>
  );
};
